import React from "react";
import {
  Wrapper,
  EditIcon,
  Viewer,
  ViewerLink,
  Editor,
  ButtonMediumPrimary
} from "./DynamicInput--styles";
import { SIZE_TO_STYLE } from "./DynamicInput_constants.js";

export default class DynamicInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editMode: false,
      text: props.text
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.text != this.props.text) {
      this.setState({
        text: this.props.text
      });
    }
  }

  keyboardFunctions(event) {
    if (event.key === "Escape" && this.state && this.state.editMode) {
      this.setState({ editMode: false });
    }
    if (event.key === "Enter" && this.state && this.state.editMode) {
      this.onSaveChangesClicked();
    }
  }

  componentDidMount() {
    document.addEventListener("keydown", this.keyboardFunctions.bind(this), false);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.keyboardFunctions.bind(this), false);
  }

  onTextChanged(e) {
    const text = e.target.value;
    this.setState({
      text
    });
  }

  onSaveChangesClicked() {
    this.toggleEdit();
    this.props.onSaveChanges(this.state.text);
  }

  editModeTrackEvent() {
    if (this.state.editMode) {
      const { organization = {}, userProfile = {} } = this.props;

      if (window.analytics) {
        window.analytics.track("Button Clicked", {
          source: "Campaign Read",
          field: "Edit Campaign Name",
          organizationId: organization?.organizationId,
          organizationName: organization?.orgaName,
          userId: userProfile?.userId,
          userName: userProfile?.userName
        });
      }
    }
  }

  toggleEdit() {
    this.setState(
      {
        editMode: !this.state.editMode
      },
      () => this.editModeTrackEvent()
    );
  }

  render() {
    const { text = "", editMode } = this.state;
    const { size = "large", type } = this.props;

    return (
      <Wrapper>
        {type != "link" && !editMode && <Viewer {...SIZE_TO_STYLE[size]}>{text}</Viewer>}
        {type == "link" && !editMode && (
          <ViewerLink href={text} target="_blank" {...SIZE_TO_STYLE[size]}>
            {text}
          </ViewerLink>
        )}
        {!editMode && (
          <EditIcon src="/images/icon-new__edit.svg" onClick={this.toggleEdit.bind(this)} />
        )}
        {editMode && (
          <Editor
            {...SIZE_TO_STYLE[size]}
            type="text"
            value={text}
            onChange={this.onTextChanged.bind(this)}
          />
        )}
        {editMode && (
          <ButtonMediumPrimary onClick={this.onSaveChangesClicked.bind(this)}>
            <i className="fa fa-save" />
          </ButtonMediumPrimary>
        )}
      </Wrapper>
    );
  }
}
